//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import CustomAvatar from '../../../components/basic/customAvatar'

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'

//style
import './AddEditMonitoredShops.scss'


@inject('translate')
@inject('internal')
@observer
export default class AddEditMonitoredShops extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      data: [],
      selected: [],
      name: '',
      domain: '',
      xpath: '',
    }
  }
  
  isEditMode = null
  
  componentDidMount() {
    
    this.isEditMode = toJS(this.props.internal.actionEdit)
    
    if (this.isEditMode.edit) {
      //load detail fixneho setu
      this.loadItem()
    } else {
      this.setState({ loading: false })
    }
  }
  
  itemData = {}
  loadItem = async () => {
    let idItem = toJS(this.props.internal.actionEdit.id)
    
    let load_item = await api({
      method: 'get',
      url: `lists/monitored-shops/${idItem}`,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_item.success) {
      this.itemData = load_item.data.data
      this.setState({
        loading: false,
        name: load_item.data.data.name,
        domain: load_item.data.data.domain,
        xpath: load_item.data.data.xpath,
      })
    }
  }
  
  action = () => {
    let isEdit = toJS(this.props.internal.actionEdit.edit)
    this.setState({ loadingBtn: true })
    if (isEdit) {
      //update
      this.updateItem()
    } else {
      //create
      this.createItem()
    }
  }
  
  updateItem = async () => {
    let name = this.name.state.value
    let domain = this.domain.state.value
    let xpath = this.xpath.state.value
    if (name !== '' && domain !== '') {
      let idItem = toJS(this.props.internal.actionEdit.id)
      
      let update_data = await api({
        method: 'patch',
        url: `lists/monitored-shops/${idItem}`,
        authorization: this.props.internal.user.access_token,
        params: {
          name,
          domain,
          xpath,
        },
      })
      
      if (update_data.success === true) {
          this.props.internal.setSnackbar(update_data.data.message, true)
          this.setState({ loadingBtn: false })
          this.props.onClose(true)
      } else {
        if (update_data.data.data.hasOwnProperty('errors')) {
          const firstKey = Object.keys(update_data.data.data.errors).shift()
          this.props.internal.setSnackbar(update_data.data.data.errors[firstKey][0], true)
        } else {
          this.props.internal.setSnackbar(update_data.data.message, true)
        }
        this.setState({ loadingBtn: false })
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }
    
  }
  
  createItem = async () => {
    let name = this.name.state.value
    let domain = this.domain.state.value
    let xpath = this.xpath.state.value
    if (name !== '' && domain !== '') {
      this.setState({ loadingBtn: true })
      let update_data = await api({
        method: 'post',
        url: `lists/monitored-shops`,
        authorization: this.props.internal.user.access_token,
        params: {
          name,
          domain,
          xpath,
        },
      })
      
      if (update_data.success === true || (update_data.success === false && update_data.status === 201)) {
        this.props.internal.setSnackbar(update_data.data.message, true)
        this.setState({ loadingBtn: false })
        this.props.onClose(true)
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }
    
  }
  
  editCategory = {}
  
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.onClose(false)}
        aria-labelledby="form-dialog-title"
        scroll={'body'}
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        {this.state.loading
          ?
          <div style={{ minHeight: '100px' }}>
            <CircularProgress className={'circular-progress'}/>
          </div>
          :
          <DialogContent>
            <CustomInput
              ref={ref => this.name = ref}
              text={this.props.translate.i18n.MODULES['FIXED-SETS'].TITLE}
              value={this.state.name}
              id={'title'}
              className={'w-100'}
              required
            />
            <CustomInput
              ref={ref => this.domain = ref}
              text={this.props.translate.i18n.MODULES['MONITORED_SHOPS'].DOMAIN}
              value={this.state.domain}
              id={'domain'}
              className={'w-100'}
              required
            />
            <CustomInput
              ref={ref => this.xpath = ref}
              text={this.props.translate.i18n.MODULES['MONITORED_SHOPS'].XPATH}
              value={this.state.xpath}
              id={'xpath'}
              className={'w-100'}
            />
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          <CustomButton
            progressBar={this.state.loadingBtn}
            onClick={this.action}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            justText
            disabled={this.state.loading}
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/MonitoredShops/AddEdit/AddEditMonitoredShops.js